import { GetStockItem_stockItem_species } from "api/Medicine/types/GetStockItem";

export const getMedicineSpeciesAsString = (species: GetStockItem_stockItem_species[]): string =>
  species.map((item) => item.name).join(", ");
